import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from '../../../../constants/layout/store/filterSlice';


const RepairableAssetsList = () => {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation()
    const passedState = location.state;

    useEffect(() => {
        dispatch(updateNavbarHeading(passedState ? passedState?.text : "Repairable Assets"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [assetRepairListData, setAssetRepairListData] = useState([]);
    const [loading, setLoading] = useState(true);


    const columns = {
        AssetName: { text: "Asset Name", width: "60px", align: "start", visible: true },
        Description: { text: "Description", width: "180px", align: "left", visible: true },
        Remarks: { text: "Issue", width: "160px", align: "center", visible: true },

    };

    useEffect(() => {
        fetchRepairableAssets()
    }, []);
    const [apiStatus, SetApiStatus] = useState(undefined);

    const fetchRepairableAssets = async () => {
        try {
            const response = await GetServiceCaller(`${API_URL}asset-repairable`);
            SetApiStatus(response?.status);
            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                setAssetRepairListData(cleanedData);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch repairable asset api. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching repairable asset api:", error);
        }
    };


    const handleAddRepair = (id) => {
        navigate(`/repairable-assets/add/${id.AssetID}`)
    }

    const handleEdit = (id) => {
        navigate(`/repairable-assets/edit/${id.RowID}`)
    }


    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <Dynamic_PR_table
                            data={assetRepairListData}
                            columns={columns}
                            itemsPerPage={10}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            isApiStatus={apiStatus}
                            isRequiredStatus={true}
                            showIcon1={true}
                            showIcon2={true}
                            isSorting={true}
                            isActionRequired={true}
                            isAddNewBtnRequired={false}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            handleIcon1={handleAddRepair}
                            handleIcon2={handleEdit}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i className="bi bi-file-earmark-plus icons"></i>,
                                Icon1Text: "Add",
                                Icon1Flag: ["canAdd"],
                                Icon2: <i class="bi bi-pencil-square icons"></i>,
                                Icon2Text: " Edit",
                                Icon2Flag: "canEdit",
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default RepairableAssetsList